import POSPage from '@/pages/POSPage'

export default function AdminPage() {
  return <POSPage view="admin" />
}

